import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20panoramic%20illustration%2C%20magical%20fantasy%20library%20with%20floating%20comic%20books%20and%20glowing%20pages%2C%20warm%20golden%20and%20soft%20pink%20tones%2C%20dreamy%20ethereal%20atmosphere%2C%20artistic%20stylized%20background%20with%20soft%20bokeh%20effects%2C%20abstract%20comic%20panel%20elements%20floating%20in%20air%2C%20clean%20gradient%20sky%2C%20beautiful%20harmonious%20color%20palette%2C%20editorial%20quality%20digital%20art&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫漫画网站 - 海量正版漫画在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
            海量正版<span className="text-primary-300">韩漫</span>，免费在线阅读
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            汇集浪漫、奇幻、动作、悬疑等海量热门韩国漫画，正版授权，高清画质，为您带来极致的在线阅读体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/category/all" className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer">
              开始阅读 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
            <Link to="/about" className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap cursor-pointer border border-white/20">
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">10,000+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">漫画作品</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">500万+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">活跃读者</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">99.9%</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">正版率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}